import React from "react";
import { useLocation } from "react-router-dom";
import ParkMobileDetailInfo  from "../../components/Detail/_ParkMobileDetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

  
function ParkMobileDetail() {
    let query = useQuery();

    return (
        <div>
           <ParkMobileDetailInfo ID={query.get("ID")} department={query.get("Dept")}/>
        </div>
    );
}

export default ParkMobileDetail;